/* eslint-disable complexity */
import "./header.scss";

import { Image } from "react-bootstrap";
import { ItasGive, LeftIcon } from "src/assets";
import { typedMemo } from "src/types";
import { useHeader } from "./header.hook";
import { lowerLanguage, upperLanguage } from "src/i18n";

export const Header = typedMemo(() => {
  const {
    showLanguagesMenu,
    dropdownRef,
    languages,
    noShadhow,
    isNotLanding,
    toggleShowLanguagesMenu,
    handleChangeLanguage,
    goToLanding,
  } = useHeader();

  const Logo = (
    <Image
      className={"header-logo"}
      src={ItasGive}
      onClick={() => goToLanding()}
    />
  );

  /*const LanguageDropdownMenu = (
    <div ref={dropdownRef} className="position-relative">
      <div
        onClick={toggleShowLanguagesMenu}
        className="d-flex align-items-center fw-bold cursor-pointer"
      >
        <span className="me-1">{upperLanguage}</span>
        <Image
          src={LeftIcon}
          width={15}
          height={12}
          className={`input-select--icon transition-transform ${
            showLanguagesMenu ? "input-select--rotate" : ""
          }`}
          style={{ transition: "transform 0.2s ease" }}
        />
      </div>

      {showLanguagesMenu && (
        <div className="languages-dropdown-menu">
          {languages
            .filter((lang) => lang !== lowerLanguage)
            .map((lang) => (
              <div
                key={lang}
                onClick={() => handleChangeLanguage(lang)}
                className="language-dropdown-item"
              >
                {lang.toUpperCase()}
              </div>
            ))}
        </div>
      )}
    </div>
  );*/

  return (
    <div>
      <header
        className={`${
          isNotLanding
            ? `header-navbar${noShadhow ? "--no-shadow" : ""}`
            : "header-navbar-landing"
        }`}
      >
        {Logo}
        {/*LanguageDropdownMenu*/}
      </header>
    </div>
  );
});
